<template>
  <v-container
    class="nx-dashboard-page"
    fluid
    fill-height
  >
    <v-layout
      row
      wrap
      align-content-start
      fill-height
    >
      <v-flex
        xs12
        class="mb-3"
      >
        <nx-dashboard-menu-card :items="menu" />
      </v-flex>
      <v-flex
        xs12
        md6
        :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }"
      >
        <component
          :is="card.component"
          v-for="card in leftColumnCards"
          :key="card.id"
          v-bind="card"
        />
      </v-flex>
      <v-flex
        xs12
        md6
        :class="{ 'pl-2': $vuetify.breakpoint.mdAndUp }"
      >
        <component
          :is="card.component"
          v-for="card in rightColumnCards"
          :key="card.id"
          class="mb-3"
          v-bind="card"
        />
      </v-flex>
    </v-layout>
    <nx-staff-revert-homepage-snackbar v-if="displayModal" />
  </v-container>
</template>

<script>
import BasePage from '@/pages/BasePage';
import NxDashboardMenuCard from '@/modules/dashboard/components/DashboardMenuCard';
import DashboardStoredSearchesCard from '@/modules/dashboard/components/DashboardStoredSearchesCard';
import DashboardPublicationsCard from '@/modules/dashboard/components/DashboardPublicationsCard';
import DashboardShortcutsCard from '@/modules/dashboard/components/DashboardShortcutsCard';
import DashboardActivityCard from '@/modules/dashboard/components/DashboardActivityCard';
import { mapGetters, mapState } from 'vuex';
import NxStaffRevertHomepageSnackbar from '@/modules/staff/components/StaffRevertHomepageSnackbar.vue';

export default {
  name: 'NxDashboardPage',
  components: {
    NxStaffRevertHomepageSnackbar,
    NxDashboardMenuCard,
    DashboardPublicationsCard,
    DashboardActivityCard,
    DashboardShortcutsCard,
    DashboardStoredSearchesCard,
  },
  extends: BasePage,
  computed: {
    ...mapState('dashboard', ['menu', 'leftColumnCards', 'rightColumnCards']),
    ...mapGetters('dashboard', ['showDashboardRevertHomepage']),
  },
  data() {
    return {
      displayModal: false,
    };
  },
  metaInfo() {
    return {
      title: 'Panel de control | BCubeCMS',
    };
  },
  async mounted() {
    this.displayModal = this.showDashboardRevertHomepage;
    this.finishLoading('Dashboard');
  },
};
</script>
